export default __webpack_public_path__ + "static/media/icon-green-tick.14d4c85c.png";